import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'row justify-content-md-center',
})`
  margin-top: 25px;

  .title-debitos {
    width: 100%;
    text-align: center;
    font-size: 20px;
    text-decoration: underline;
    margin-top: 0;
    margin-bottom: 10px;
  }

  .btn-pagamento-total-debitos {
    svg {
      margin-right: 5px;
      margin-bottom: 3px;
    }
  }

  .btn-selecionar-mais-debitos {
    svg {
      margin-right: 5px;
      margin-bottom: 3px;
    }
  }

  .checkbox-gerar-boletos-separadamente {
    text-align: right;
    margin-right: 20px;
  }

  .base-buttons-actions-selecao-debitos-secondary {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .buttons-secondary {
      display: flex;
      justify-content: flex-start;
    }
    .info-valor-debitos-selecionados {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        margin-bottom: 0;
        text-align: center;
      }
    }
  }
`;
